import { render, staticRenderFns } from "./BillOfProcessDetailUpload.vue?vue&type=template&id=5fbb6019&"
import script from "./BillOfProcessDetailUpload.vue?vue&type=script&lang=js&"
export * from "./BillOfProcessDetailUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports